import './styles/global.css';
import { CityProvider } from './contexts/CityContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { AuthProvider } from './contexts/AuthContext';
import AppRouter from './Router'; // 'router' yerine 'Router' olarak düzeltildi
import { useEffect, useRef } from 'react';

// Ana uygulama bileşeni
function App() {
  const rootRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const root = rootRef.current;
    if (!root) return;
    const handleMove = (e: MouseEvent) => {
      const target = (e.target as HTMLElement).closest('[data-glow]') as HTMLElement | null;
      if (!target) return;
      const rect = target.getBoundingClientRect();
      const mx = ((e.clientX - rect.left) / rect.width) * 100;
      const my = ((e.clientY - rect.top) / rect.height) * 100;
      target.style.setProperty('--mx', mx + '%');
      target.style.setProperty('--my', my + '%');
    };
    const handleTouch = (e: TouchEvent) => {
      const t = e.touches[0];
      if (!t) return;
      const el = (e.target as HTMLElement).closest('[data-glow]') as HTMLElement | null;
      if (!el) return;
      const rect = el.getBoundingClientRect();
      const mx = ((t.clientX - rect.left) / rect.width) * 100;
      const my = ((t.clientY - rect.top) / rect.height) * 100;
      el.style.setProperty('--mx', mx + '%');
      el.style.setProperty('--my', my + '%');
      el.classList.add('touching');
    };
    const clearTouch = () => {
      root.querySelectorAll('[data-glow].touching').forEach(el => el.classList.remove('touching'));
    };
    root.addEventListener('mousemove', handleMove);
    root.addEventListener('touchstart', handleTouch, { passive: true });
    root.addEventListener('touchmove', handleTouch, { passive: true });
    root.addEventListener('touchend', clearTouch);
    return () => {
      root.removeEventListener('mousemove', handleMove);
      root.removeEventListener('touchstart', handleTouch);
      root.removeEventListener('touchmove', handleTouch);
      root.removeEventListener('touchend', clearTouch);
    };
  }, []);

  return (
      <div ref={rootRef} className="app-root-glow">
        <ThemeProvider>
          <AuthProvider>
            <CityProvider>
              <AppRouter />
            </CityProvider>
          </AuthProvider>
        </ThemeProvider>
      </div>
  );
}

export default App;
